var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { api_service } from '../../../api/api_service';
import { api_urls } from '../../../api/api_urls';
import constants, { APPLICATION_TYPES, FIELD_CONFIG_KEY_BY_APPLICATION_TYPE, } from '../../../config/constants';
var SUCCESS_STATUS_CODE = 200;
var PORTAL_ERROR_MESSAGE = 'We could not load the portals. Please try again.';
var PROGRAM_ERROR_MESSAGE = 'We could not load the programs. Please try again.';
var DEALER_ERROR_MESSAGE = 'We could not load the dealerships for this program.';
var LOCATION_ERROR_MESSAGE = 'We could not load the locations for this dealership.';
var SALES_REP_ERROR_MESSAGE = 'We could not load the sales reps for this location.';
var FIELD_CONFIG_ERROR_MESSAGE = 'We could not load the form configuration for this dealership. Please try again.';
var readResponseRows = function (response) {
    var _a;
    var payload = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data;
    if (Array.isArray(payload)) {
        return payload;
    }
    var nestedCollection = [
        payload === null || payload === void 0 ? void 0 : payload.Programs,
        payload === null || payload === void 0 ? void 0 : payload.Locations,
        payload === null || payload === void 0 ? void 0 : payload.SalesReps,
        payload === null || payload === void 0 ? void 0 : payload.SalesRepsList,
        payload === null || payload === void 0 ? void 0 : payload.Dealers,
        payload === null || payload === void 0 ? void 0 : payload.Vendors,
    ].find(function (collection) { return Array.isArray(collection); });
    if (nestedCollection) {
        return nestedCollection;
    }
    return payload && typeof payload === 'object' ? [payload] : [];
};
var isUsableOption = function (option) {
    return option.label !== '' && option.value !== '' && option.value !== null && option.value !== undefined;
};
var toText = function (value) { return (value === null || value === undefined ? '' : String(value)); };
var pickText = function (row) {
    var fieldNames = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        fieldNames[_i - 1] = arguments[_i];
    }
    for (var index = 0; index < fieldNames.length; index += 1) {
        var value = toText(row === null || row === void 0 ? void 0 : row[fieldNames[index]]).trim();
        if (value) {
            return value;
        }
    }
    return '';
};
var pickPersonName = function (row) {
    var fullName = [
        pickText(row, 'FirstName', 'FName', 'GivenName'),
        pickText(row, 'LastName', 'LName', 'SurName', 'Surname'),
    ]
        .filter(Boolean)
        .join(' ');
    return fullName || pickText(row, 'Name', 'SalesRepName', 'FullName', 'DisplayName', 'Email');
};
var toOptions = function (rows, mapRow) { return rows.map(mapRow).filter(isUsableOption); };
var requestRows = function (request, fallbackErrorMessage) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 2, , 3]);
                return [4, request()];
            case 1:
                response = _d.sent();
                if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) !== SUCCESS_STATUS_CODE) {
                    return [2, { rows: [], errorMessage: (_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : fallbackErrorMessage }];
                }
                return [2, { rows: readResponseRows(response), errorMessage: '' }];
            case 2:
                error_1 = _d.sent();
                return [2, { rows: [], errorMessage: fallbackErrorMessage }];
            case 3: return [2];
        }
    });
}); };
var runLookup = function (request, mapRows, fallbackErrorMessage) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, rows, errorMessage;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4, requestRows(request, fallbackErrorMessage)];
            case 1:
                _a = _b.sent(), rows = _a.rows, errorMessage = _a.errorMessage;
                return [2, { options: errorMessage ? [] : mapRows(rows), errorMessage: errorMessage }];
        }
    });
}); };
var LOOKUP_REQUEST_OPTIONS = { showLoader: false };
var fetchPortals = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2, runLookup(function () { return api_service.get(__assign({ endPoint: api_urls.VENDOR_LIST }, LOOKUP_REQUEST_OPTIONS)); }, function (rows) {
                return toOptions(rows, function (vendor) { return ({
                    label: pickText(vendor, 'Name', 'PortalType'),
                    value: pickText(vendor, 'Id'),
                }); });
            }, PORTAL_ERROR_MESSAGE)];
    });
}); };
export var fetchProgramCatalogue = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2, runLookup(function () { return api_service.get(__assign({ endPoint: api_urls.PROGRAMS_LIST }, LOOKUP_REQUEST_OPTIONS)); }, function (rows) {
                return toOptions(rows, function (program) { return ({
                    label: pickText(program, 'Name', 'ProgramName'),
                    value: pickText(program, 'Id', 'ProgramId'),
                    programAspireOId: pickText(program, 'ProgramAspireOId'),
                    country: pickText(program, 'Country'),
                }); }).sort(function (left, right) { return left.label.localeCompare(right.label); });
            }, PROGRAM_ERROR_MESSAGE)];
    });
}); };
var splitList = function (value) {
    if (Array.isArray(value)) {
        return value.map(toText).map(function (item) { return item.trim(); }).filter(Boolean);
    }
    if (typeof value === 'string') {
        return value.split(',').map(function (item) { return item.trim(); }).filter(Boolean);
    }
    return [];
};
var fetchProgramIdsByName = function (portalId) { return __awaiter(void 0, void 0, void 0, function () {
    var idsByName, rows;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                idsByName = new Map();
                return [4, requestRows(function () {
                        return api_service.get(__assign({ endPoint: api_urls.BACKLOG_PROGRAMS_LIST, payLoad: { VendorId: portalId } }, LOOKUP_REQUEST_OPTIONS));
                    }, PROGRAM_ERROR_MESSAGE)];
            case 1:
                rows = (_a.sent()).rows;
                rows.forEach(function (program) {
                    var programName = pickText(program, 'Name', 'ProgramName');
                    var programId = pickText(program, 'Id', 'ProgramId');
                    if (programName && programId) {
                        idsByName.set(programName.toLowerCase(), {
                            programId: programId,
                            programAspireOId: pickText(program, 'ProgramAspireOId'),
                            country: pickText(program, 'Country'),
                        });
                    }
                });
                return [2, idsByName];
        }
    });
}); };
var toProgramOptions = function (rows, programIdsByName) {
    var optionsByName = new Map();
    var addOption = function (label, value, dealerAccountAspireOId) {
        var _a, _b, _c;
        var optionLabel = label.trim();
        var optionKey = optionLabel.toLowerCase();
        if (!optionLabel || optionsByName.has(optionKey)) {
            return;
        }
        var catalogueIds = programIdsByName.get(optionKey);
        var optionValue = (_a = catalogueIds === null || catalogueIds === void 0 ? void 0 : catalogueIds.programId) !== null && _a !== void 0 ? _a : (value.trim() || optionLabel);
        optionsByName.set(optionKey, {
            label: optionLabel,
            value: optionValue,
            dealerAccountAspireOId: dealerAccountAspireOId,
            programAspireOId: (_b = catalogueIds === null || catalogueIds === void 0 ? void 0 : catalogueIds.programAspireOId) !== null && _b !== void 0 ? _b : '',
            country: (_c = catalogueIds === null || catalogueIds === void 0 ? void 0 : catalogueIds.country) !== null && _c !== void 0 ? _c : '',
        });
    };
    rows.forEach(function (row) {
        var rowDealerAspireOId = pickText(row, 'DealerAccountAspireOId', 'DealerAspireOId');
        var programName = pickText(row, 'Name', 'ProgramName');
        if (programName) {
            addOption(programName, pickText(row, 'Id', 'ProgramId'), rowDealerAspireOId);
            return;
        }
        if (Array.isArray(row === null || row === void 0 ? void 0 : row.Programs)) {
            row.Programs.forEach(function (program) {
                return addOption(pickText(program, 'Name', 'ProgramName'), pickText(program, 'Id', 'ProgramId'), rowDealerAspireOId);
            });
            return;
        }
        var programNames = splitList(row === null || row === void 0 ? void 0 : row.ProgramNames);
        var programIds = splitList(row === null || row === void 0 ? void 0 : row.ProgramIds);
        programNames.forEach(function (name, index) { var _a; return addOption(name, (_a = programIds[index]) !== null && _a !== void 0 ? _a : '', rowDealerAspireOId); });
    });
    return Array.from(optionsByName.values());
};
var fetchPrograms = function (portalId) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b, rows, errorMessage, programIdsByName;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, Promise.all([
                    requestRows(function () {
                        return api_service.get(__assign({ endPoint: api_urls.DEALER_PROG_ASSOCIATION_LIST, payLoad: { VendorId: portalId } }, LOOKUP_REQUEST_OPTIONS));
                    }, PROGRAM_ERROR_MESSAGE),
                    fetchProgramIdsByName(portalId),
                ])];
            case 1:
                _a = _c.sent(), _b = _a[0], rows = _b.rows, errorMessage = _b.errorMessage, programIdsByName = _a[1];
                if (errorMessage) {
                    return [2, { options: [], errorMessage: errorMessage }];
                }
                return [2, { options: toProgramOptions(rows, programIdsByName), errorMessage: '' }];
        }
    });
}); };
export var fetchDealerships = function (programId) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, rows, errorMessage, dealersByOId;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4, requestRows(function () {
                    return api_service.get(__assign({ endPoint: api_urls.PROGRAM_VENDOR_DEALERS, payLoad: { ProgramId: programId } }, LOOKUP_REQUEST_OPTIONS));
                }, DEALER_ERROR_MESSAGE)];
            case 1:
                _a = _b.sent(), rows = _a.rows, errorMessage = _a.errorMessage;
                if (errorMessage) {
                    return [2, { options: [], errorMessage: errorMessage, vendorId: '' }];
                }
                dealersByOId = new Map();
                rows.forEach(function (vendor) {
                    var _a;
                    return ((_a = vendor === null || vendor === void 0 ? void 0 : vendor.Dealers) !== null && _a !== void 0 ? _a : []).forEach(function (dealer) {
                        return dealersByOId.set(pickText(dealer, 'DealerAccountAspireOId'), dealer);
                    });
                });
                return [2, {
                        options: toOptions(Array.from(dealersByOId.values()), function (dealer) { return ({
                            label: pickText(dealer, 'DealerName'),
                            value: pickText(dealer, 'DealerAccountAspireOId'),
                        }); }),
                        errorMessage: '',
                        vendorId: pickText(rows[0], 'VendorId'),
                    }];
        }
    });
}); };
export var fetchLocations = function (dealerAspireOId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2, runLookup(function () {
                return api_service.get(__assign({ endPoint: api_urls.LOCATION_LIST, payLoad: { DealerAspireOId: dealerAspireOId } }, LOOKUP_REQUEST_OPTIONS));
            }, function (rows) {
                return toOptions(rows, function (location) {
                    var locationAspireOId = pickText(location, 'LocationAspireOId', 'LocationAspireOID', 'LocationOId', 'AspireOId', 'OId', 'Id');
                    return {
                        label: pickText(location, 'Name', 'LocationName', 'LocationDescription', 'Description', 'Address'),
                        value: locationAspireOId,
                        locationAspireOId: locationAspireOId,
                        locationCode: pickText(location, 'LocationCode', 'Code', 'LocCode'),
                    };
                });
            }, LOCATION_ERROR_MESSAGE)];
    });
}); };
export var fetchSalesReps = function (dealerAspireOId, locationAspireOId, locationCode) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2, runLookup(function () {
                return api_service.get(__assign({ endPoint: api_urls.LOCATION_SALES_REPS, payLoad: {
                        DealerAspireOId: dealerAspireOId,
                        LocationAspireOId: locationAspireOId,
                        LocationCode: locationCode,
                    } }, LOOKUP_REQUEST_OPTIONS));
            }, function (rows) {
                return toOptions(rows, function (salesRep) { return ({
                    label: pickPersonName(salesRep),
                    value: pickText(salesRep, 'Id', 'AccountAspireId'),
                    accountAspireId: pickText(salesRep, 'AccountAspireId'),
                }); });
            }, SALES_REP_ERROR_MESSAGE)];
    });
}); };
var parseFieldConfigBlob = function (blob) {
    if (!blob) {
        return null;
    }
    if (typeof blob === 'string') {
        try {
            return JSON.parse(blob);
        }
        catch (error) {
            return null;
        }
    }
    return typeof blob === 'object' ? blob : null;
};
export var fetchVendorConfigDetails = function (vendorId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!vendorId) {
                    return [2, null];
                }
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                return [4, api_service.get(__assign({ endPoint: api_urls.DEALER_DETAILS_BY_ID, payLoad: { VendorId: Number(vendorId) } }, LOOKUP_REQUEST_OPTIONS))];
            case 2:
                response = _c.sent();
                if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) !== 200) {
                    return [2, null];
                }
                return [2, ((_b = response.data.data) !== null && _b !== void 0 ? _b : null)];
            case 3:
                error_2 = _c.sent();
                return [2, null];
            case 4: return [2];
        }
    });
}); };
var fetchVendorFieldConfigBundle = function (vendorId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, payload_1, configByApplicationType_1, error_3;
    var _a, _b, _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                _f.trys.push([0, 2, , 3]);
                return [4, api_service.get(__assign({ endPoint: api_urls.GET_FIELD_CONFIG_DATA, payLoad: { VendorId: vendorId } }, LOOKUP_REQUEST_OPTIONS))];
            case 1:
                response = _f.sent();
                if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) !== SUCCESS_STATUS_CODE) {
                    return [2, {
                            bundle: null,
                            errorMessage: (_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : FIELD_CONFIG_ERROR_MESSAGE,
                        }];
                }
                payload_1 = (_e = (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.data) !== null && _e !== void 0 ? _e : {};
                configByApplicationType_1 = {};
                Object.keys(FIELD_CONFIG_KEY_BY_APPLICATION_TYPE).forEach(function (applicationType) {
                    var configKey = FIELD_CONFIG_KEY_BY_APPLICATION_TYPE[applicationType];
                    configByApplicationType_1[applicationType] = parseFieldConfigBlob(payload_1 === null || payload_1 === void 0 ? void 0 : payload_1[configKey]);
                });
                return [2, {
                        bundle: {
                            configByApplicationType: configByApplicationType_1,
                            availableKeys: Object.keys(payload_1).filter(function (key) { return Boolean(payload_1[key]); }),
                        },
                        errorMessage: '',
                    }];
            case 2:
                error_3 = _f.sent();
                return [2, { bundle: null, errorMessage: FIELD_CONFIG_ERROR_MESSAGE }];
            case 3: return [2];
        }
    });
}); };
var DEFAULT_CONFIG_BY_APPLICATION_TYPE = (_a = {},
    _a[APPLICATION_TYPES.NOR] = constants.NorAppObjJSON,
    _a[APPLICATION_TYPES.LOC] = constants.LocAppObjJSON,
    _a[APPLICATION_TYPES.DORF] = constants.LocAppObjJSON,
    _a[APPLICATION_TYPES.SCH] = constants.SchAppObjJSON,
    _a);
var isEmptyFieldConfig = function (config) {
    return !config ||
        Object.keys(config).every(function (groupName) {
            var _a, _b;
            var sections = (_b = (_a = config[groupName]) === null || _a === void 0 ? void 0 : _a.sections) !== null && _b !== void 0 ? _b : {};
            return Object.keys(sections).every(function (sectionName) { var _a, _b; return ((_b = (_a = sections[sectionName]) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) === 0; });
        });
};
export var getFieldConfigForApplicationType = function (bundle, applicationType) {
    var _a, _b, _c;
    var published = (_b = (_a = bundle === null || bundle === void 0 ? void 0 : bundle.configByApplicationType) === null || _a === void 0 ? void 0 : _a[applicationType]) !== null && _b !== void 0 ? _b : null;
    return isEmptyFieldConfig(published)
        ? (_c = DEFAULT_CONFIG_BY_APPLICATION_TYPE[applicationType]) !== null && _c !== void 0 ? _c : null
        : published;
};
